import axios from 'axios';
import config from 'config';
// Metrics
import ReactGA from 'react-ga';
import ym, { YMInitializer } from 'react-yandex-metrika';

export const initMetrics = () => {
  const { GAId, ymId } = config;
  // init google analytics
  if (GAId) {
    ReactGA.initialize(GAId);
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  // init Yandex analytics
  if (ymId) {
    return (
      <YMInitializer
        accounts={[ymId]}
        options={{
          clickmap: true,
          trackLinks: true,
          accurateTrackBounce: true,
          webvisor: true
        }}
        version="2"
      />
    );
  }
};

export const sendMetricsEvent = (gConfig, yConfig) => {
  // Google
  if (gConfig && typeof gConfig === 'object' && gConfig.category && gConfig.action) {
    ReactGA.event(gConfig);
  }

  // Yandex
  if (yConfig && yConfig.type && yConfig.target) {
    try {
      ym(yConfig.type, yConfig.target, yConfig.cb);
      return true;
    } catch (e) {
      axios.get(
        `${config.api}auth/ping?yandex-error=true&target=${yConfig.target}&message=${e.message}`
      );
    }
  }
};
